import axios from 'App/axios';

export enum FeatureFlag {
  // PagoNube
  FS_PAGONUBE_TRANSFER_DISABLED = 'fs-pagonube-transfer-disabled',
  FS_PAGONUBE_QR_MODO_ENABLED = 'fs-pagonube-qr-modo-enable',
  FS_PAGONUBE_D30_AVAILABLE_FOR_ARGENTINA_STORE = 'fs-pagonube-d30-available-for-argentina-store',
  FS_PAGONUBE_PARTIAL_WITHDRAW_ENABLED = 'fs-pagonube-partial-withdraw-enabled',
  FS_PAGONUBE_PAYMENT_PROVIDER_WITHDRAWALS_DISABLED = 'fs-pagonube-payment-provider-withdrawals-disabled',
  FS_PAGONUBE_BANKING_WITHDRAWALS_DISABLED = 'fs-pagonube-banking-withdrawals-disabled',
  FS_PAGONUBE_MX_INSTALLMENT_MIN_AMOUNT_VALIDATION = 'fs-pagonube-mx-installment-min-amount-validation',
  FS_PAGONUBE_RPG_TRANSACTION_REPORT_ENABLED = 'fs-pagonube-rpg-transaction-report-enabled',
  FS_PAGONUBE_FEE_CALCULATOR_ENABLED = 'fs-pagonube-fee-calculator-enabled',
  FS_PAGONUBE_AIPRISE_KYC_ENABLED = 'fs-pagonube-aiprise-kyc-enabled',
  FS_PAGONUBE_SYNC_FLAGS_AT_BEGINNING_ENABLED = 'fs-pagonube-sync-flags-at-beginning-enabled',
  FS_COMMONS_PROOF_OF_LIFE_URL_ENDPOINT_ENABLED = 'fs-commons-proof-of-life-url-endpoint-enabled',

  // NuvemPago
  FS_NUVEMPAGO_REFUND_PARTIAL_ROLLOUT = 'fs-nuvempago-refund-partial-rollout',
  FS_NUVEMPAGO_WITHDRAW_ROLLOUT = 'fs-nuvempago-withdraw-rollout',
  FS_NUVEMPAGO_REFUND_PIX = 'fs-nuvempago-refund-pix',
  FS_NUVEMPAGO_DISCOUNT_LABEL = 'fs-nuvempago-discount-label',
  FS_NUVEMPAGO_REFUND_RECEIPT_ENABLE = 'fs-nuvempago-refund-receipt-enable',
  FS_NUVEMPAGO_PARTIAL_REFUND_PIX = 'fs-nuvempago-partial-refund-pix',
  FS_NUVEMPAGO_REFUND_RESTOCK = 'fs-nuvempago-refund-restock',
  FS_NUVEMPAGO_REFUND_RECEIPT_FRONTEND_PDF_EXPORT = 'fs-nuvempago-refund-receipt-frontend-pdf-export',
  FS_NUVEMPAGO_KYC_REJECT_NOTIFICATION_BY_COMMONS = 'fs-nuvempago-kyc-reject-notification-by-commons',
  FS_NUVEMPAGO_2FA_ENABLED = 'fs-nuvempago-2fa-enabled',
  FS_VALIDATE_USER_ROLE = 'fs-validate-user-role',
  FS_NUVEMPAGO_DASHBOARD_DATA_FROM_COMMONS = 'fs-nuvempago-dashboard-data-from-commons',
  FS_NUVEMPAGO_NEW_LANDING_EXPERIENCE = 'fs-nuvempago-new-landing-experience',
  FS_NUVEMPAGO_NEW_PROVIDER_CONFIGURATION_ENABLED = 'fs-nuvempago-new-provider-configuration-enabled',
  FS_PAGONUBE_BATCH_PROCESS_BALANCE_TRANSACTIONS_ENABLED = 'fs-pagonube-mexico-batch-process-balance-transactions-enabled',
  FS_NUVEM_PAGO_BANKING_CASHOUT = 'fs-nuvempago-banking-cashout',
  FS_NUVEMPAGO_APOLLO_ROLLOUT_ACKNOWLEDGMENT = 'fs-nuvempago-apollo-rollout-acknowledgment',
  FS_NUVEMPAGO_COLLECT_DOCUMENT = 'fs-nuvempago-apollo-collect-document',
  FAP_USE_HAS_FEATURE_ENABLED = 'fap-use-has-feature-enabled',
  STATEMENT_REPORT = 'fs-nuvempago-statement-feature',
  FS_NUVEMPAGO_STATEMENT_RESUME = 'fs-nuvempago-statement-resume',
  FS_NUVEMPAGO_INCOME_REPORT_CARD_ENABLED = 'fs-nuvempago-income-report-card-enabled',
  FS_PAGONUBE_BANK_ACCOUNT_EDIT_BLOCKED = 'fs-pagonube-bank-account-edit-blocked',
  FS_NUVEMPAGO_MULTI_OWNERSHIP_SELECTION = 'ft-bk-acc-k8s-checking-multi-ownership-selection',
  FS_NUVEMPAGO_CHARGEBACK_UPLOAD = 'fs-nuvempago-chargeback-upload',
  FS_NUVEMPAGO_CHARGEBACK_DEFENSE_ROLE = 'fs-nuvempago-chargeback-defense-role',
  FS_NUVEMPAGO_DEFENSE_MODEL = 'fs-nuvempago-defense-model',
  FS_NUVEMPAGO_CONFIGURE_ROLE = 'fs-nuvempago-configure-role',
  FS_NUVEMPAGO_BALANCE_STATEMENT_ROLE = 'fs-nuvempago-balance-statement-role',
  FS_NUVEMPAGO_PAYMENT_LINK_ROLE = 'fs-nuvempago-payment-link-role',
  FS_NUVEMPAGO_STATEMENT_FILTERS = 'fs-nuvempago-statement-filters',
  FS_NUVEMPAGO_STATEMENT_EXPORT_PAGE = 'fs-nuvempago-statement-export-page',
  FS_NUVEMPAGO_STATEMENT_PNF_ENABLED = 'fs-nuvempago-statement-pnf-enabled',
  FS_NUVEMPAGO_ENRICH_ON_ACTIVATION = 'fs-nuvempago-enrich-on-activation',
  FS_NUVEMPAGO_PROTEGE_MAIS_FLOW = 'ft-bk-acc-k8s-checking-protege-mais-upgrade-unlock',
  FS_NUVEMPAGO_WITHDRAW_PERMISSION = 'fs-nuvempago-withdraw-permission',

  // Notifications V2
  FS_NOTIFICATIONS_V2 = 'ft-pm-ptf-k8s-notifications-fs-notifications-v2',
}

type IsFeatureFlagEnabledType = (
  featureFlagId: FeatureFlag,
  country?: string,
) => Promise<boolean>;

const isFeatureFlagEnabled: IsFeatureFlagEnabledType = async (
  featureFlagId: FeatureFlag,
  country?: string,
) => {
  const params = country ? { country } : {};
  const response = await axios.get(`/admin/flags/${featureFlagId}`, { params });
  return response.data;
};

interface FeatureFlagServiceInterface {
  isFeatureFlagEnabled: IsFeatureFlagEnabledType;
}

const featureFlagService: FeatureFlagServiceInterface = {
  isFeatureFlagEnabled,
};

export default featureFlagService;
